import { useI18n, type MessageKey } from '../lib/i18n';

/**
 * Bosqichlar indikatori (BT §7.2, §7.3).
 * Sotuvchi qaysi bosqichda turganini doim ko'rib turadi.
 *
 * ── Nega 6 emas, 4 ta ────────────────────────────────────────────────
 * Mijoz qarori (15.08.2026): platforma hozircha shartnoma
 * RASMIYLASHTIRMAYDI, faqat qaysi provayder qancha taklif qilayotganini
 * ko'rsatadi — tavsiya sifatida. Shartnoma bosqichlari (5 va 6) shu
 * sababli olib tashlandi, kodi esa joyida qoldi (`RECOMMEND_ONLY`).
 */

export const STEPS = [
  { id: 1, key: 'step.anketa' },
  { id: 2, key: 'step.myid' },
  { id: 3, key: 'step.scoring' },
  { id: 4, key: 'step.results' },
  // { id: 5, key: 'step.contract' },   ← shartnoma qaytarilganda ochiladi
  // { id: 6, key: 'step.done' },
] as const satisfies ReadonlyArray<{ id: number; key: MessageKey }>;

export type StepId = (typeof STEPS)[number]['id'];

interface StepperProps {
  current: StepId;
}

export function Stepper({ current }: StepperProps) {
  const { t } = useI18n();

  return (
    <nav className="stepper" aria-label={t('stepper.aria')}>
      <ol>
        {STEPS.map((step) => {
          const state = step.id < current ? 'done' : step.id === current ? 'active' : 'todo';
          return (
            <li key={step.id} className={`step step--${state}`}>
              <span className="step__badge" aria-hidden="true">
                {state === 'done' ? '✓' : step.id}
              </span>
              <span className="step__label">{t(step.key)}</span>
            </li>
          );
        })}
      </ol>
    </nav>
  );
}
